// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

let previousScrollY = 0;

$(document).on('show.bs.modal', () => {
    previousScrollY = window.scrollY;
$('html').addClass('modal-open').css({
    marginTop: -previousScrollY,
    overflow: 'hidden',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    position: 'fixed',
});

}).on('hidden.bs.modal', () => {
    $('html').removeClass('modal-open').css({
    marginTop: 0,
    overflow: 'visible',
    left: 'auto',
    right: 'auto',
    top: 'auto',
    bottom: 'auto',
    position: 'static',
});
window.scrollTo(0, previousScrollY);
});

const options = {
  rootMargin: '-40% 0% -40% 0%',
  threshold: 0,
}

const callback = function (entries) {
  entries.forEach((entry) => {
    console.log(entry);

    if (entry.isIntersecting) {
      entry.target.classList.add('animate-fadeIn');
    } else {
      entry.target.classList.remove('animate-fadeIn');
    }
  });
};

const observer = new IntersectionObserver(callback, options);

const targets = document.querySelectorAll('.js-show-on-scroll');
targets.forEach(function (target) {
  target.classList.add('opacity-0');
  observer.observe(target);
});


$( document ).ready(function() {
  $('.hamburger').click(function() {
    $(this).toggleClass('clicked');
  });

  $('.c-header-toggler').click(function() {
    $('.show-sticky').toggleClass('full-height');
  });
});



// WEBPACK FOOTER //
// ./scripts/main.js